import {
    //GET_ARTICULOS,
    SET_ARTICULOS,
    SET_CAD_BUSQUEDA,
    SET_CATEGORIAS,
    SET_FILTRAR_ARTICULOS,
    SET_RESULTS_PAGE
} from "../types";

import { 
    getArticulosR as getArts,
    jsonDeserialize
}   from "../API/request";

/**
 * 
 * Funcion que cambia la cadena de busqueda
 */
export function setCadenaBusquedaAction(inBusqueda,allArticulos) {
    return (dispatch) => {
        dispatch(setCadenaBusqueda(inBusqueda));

        let filtroByBusqueda = allArticulos.filter(articulo => articulo.nombre.toLowerCase().startsWith(inBusqueda.toLowerCase()) || articulo.nombre.toLowerCase().includes(inBusqueda.toLowerCase()) || articulo.numParte.toLowerCase().includes(inBusqueda.toLowerCase()))

        dispatch(setFiltrarArticulos(filtroByBusqueda));
    };
}
const setCadenaBusqueda = (inBusqueda) => ({
    type: SET_CAD_BUSQUEDA,
    payload: inBusqueda,
});
const setFiltrarArticulos = (filtroArticulos) => ({
    type: SET_FILTRAR_ARTICULOS,
    payload: filtroArticulos,
});
/**
 * 
 * Funcion que agrega las categorias
 */
 export function setCategoriasAction(categoriasList) {
    return (dispatch) => {
        dispatch(setCategorias(categoriasList));
    };
}
const setCategorias = (categoriasList) => ({
    type: SET_CATEGORIAS,
    payload: categoriasList,
});
/**
 * 
 * Funcion que agrega todos los articulos
 */
 export function setArticulosAction(categoriasList) {
    return (dispatch) => {
        //console.log("DESDE setArticulosAction");
        //console.log(categoriasList)


        let allArticulos = [];

        categoriasList.map((collectionDetail, i) => {
            //console.log(collectionDetail.idCategoria)

            getArts(collectionDetail.idCategoria)
            .then( ( responseArticulos ) => {
                var arts = jsonDeserialize(responseArticulos.data.data).articulos.data;
                allArticulos = allArticulos.concat(arts);

                dispatch(setArticulos(allArticulos));
            })

            return null;
        })
    };
}
const setArticulos = (articulosList) => ({
    type: SET_ARTICULOS,
    payload: articulosList,
});
/**
 * 
 * Funcion que respalda los articulos filtrados para mostrarlos en la pagina de results
 */
 export function setResultsPageAction(articulosList) {
    return (dispatch) => {
        dispatch(setResultsPage(articulosList));
    };
}
const setResultsPage = (articulosList) => ({
    type: SET_RESULTS_PAGE,
    payload: articulosList,
});